import badge1 from "../Assets/about/1.webp";
import badge2 from "../Assets/about/2.webp";
import badge3 from "../Assets/about/3.png";
import badge4 from "../Assets/about/4.webp";
import badge5 from "../Assets/about/5.webp";
import badge6 from "../Assets/about/6.png";
import badge7 from "../Assets/about/7.png";
import badge8 from "../Assets/about/8.webp";
import badge9 from "../Assets/about/9.webp";

const badges = [
  {
    id: 1,
    src: badge1,
    alt: "Meta Frontend Developer badge",
  },
  {
    id: 2,
    src: badge2,
    alt: "Cisco JavaScript Essentials 1 badge",
  },
  {
    id: 3,
    src: badge3,
    alt: "Ambassador badge",
  },
  {
    id: 4,
    src: badge4,
    alt: "Women Techmakers membership badge from Google",
  },
  {
    id: 5,
    src: badge5,
    alt: "Google Developer quiz completion badge",
  },
  {
    id: 6,
    src: badge6,
    alt: "Certificate of appreciation",
  },
  {
    id: 7,
    src: badge7,
    alt: "Certificate of participation",
  },
  {
    id: 8,
    src: badge8,
    alt: "Women in AI Summit registration badge from Google",
  },
  {
    id: 9,
    src: badge9,
    alt: "Google Developer Program membership badge",
  },
];

export default badges;
